import { formatDatetime } from './common';

/**
 * ファイル名をつけてダウンロード
 * @param url
 * @param docmentType
 * @param constructionName
 */
export const downloadPdf = (
  url: string,
  docmentType: string,
  constructionName: string
) => {
  const currentDatetime = formatDatetime(new Date(), 'YYYYMMDD');
  const fileName = `【${docmentType}】${constructionName}_${currentDatetime}.pdf`;
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  link.click();
};
